module.exports = __webpack_public_path__ + "components/media-kit/static/icon-na-1659446479763ffc199a811377513c32.svg";